/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Apis_Form_DescriptionInputs */



/**
* | output |
* | --- |
* | "Only the APIs approved here can be called. Everything else is refused before any request leaves." |
*
* @param {Integrations_Apis_Form_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_apis_form_description = /** @type {((inputs?: Integrations_Apis_Form_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Apis_Form_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur die hier freigegebenen APIs können aufgerufen werden. Alles andere wird abgewiesen, bevor eine Anfrage das System verlässt.")
	return /** @type {LocalizedString} */ ("Only the APIs approved here can be called. Everything else is refused before any request leaves.")
});